<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-item :label="'Date'" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-range-picker
                v-model="queryParam.dataDt"
                format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'ProductType'">
              <a-select
                v-model="queryParam.appssidList"
                mode='multiple'
              >
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="'Data Caliber'">
              <a-select default-value="" style="width: 190px" v-model="queryParam.dataType">
                <a-select-option value="1">
                  Registration Day
                </a-select-option>
                <a-select-option value="2">
                  Registered Near 3 Days
                </a-select-option>
                <a-select-option value="3">
                  Registered Near 7 Days
                </a-select-option>
                <a-select-option value="4">
                  Registered Near 30 Days
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
              <a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        size="middle"
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowClassName="rowClassName"
        :scroll="{ x: 2300, y: 2000 }"
        bordered
        @change="handleTableChange"
        @expand="extpand"
      >

        <a-table
          slot="expandedRowRender"
          slot-scope="text"
          ref="table"
          size="middle"
          :columns="innerColumns"
          :data-source="text.dataDetails"
          :loading="loading"
          :pagination="false"
          bordered>

        </a-table>

      </a-table>
    </div>
    <RefundTradeModal ref="modalForm" @ok="modalFormOk"></RefundTradeModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import {getApplistExcludingSubApp, getConvertInstallData} from '@/webpublicapi/order'
import Dict from '../modules/Dict';
import { REFUND_TRADE_STATUS } from '@/constants/status';
import RefundTradeModal from './modules/RefundTradeModal'
import moment from "moment";
import exportFile from "@/webpublicapi/exportFile";
export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict
  },
  data () {
    return {
      visible: false,
      REFUND_TRADE_STATUS,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      innerData: [],
      appList: [],
      // Query conditions
      queryParam: {
        dataDt: [moment().add('days', -60), moment().add('days', 0)],
        appssidList: []
      },
      loading: false,

      // Table header
      columns: [
        {
          title: 'Date',
          align: 'left',
          dataIndex: 'dataDt',
        },
        {
          title: 'APP',
          align: 'left',
          dataIndex: 'appName',
        },
        {
          title: 'Batch No.',
          align: 'left',
          dataIndex: 'appSsid',
        },
        {
          title: 'Install',
          align: 'left',
          dataIndex: 'installs',
        },
        {
          title: 'Registration',
          align: 'left',
          dataIndex: 'regCount'
        },
        {
          title: 'Basic Info',
          align: 'left',
          dataIndex: 'basicCount'
        },
        // {
        //   title: 'Work info',
        //   align: 'left',
        //   dataIndex: 'workCount'
        // },
        {
          title: 'Contact',
          align: 'left',
          dataIndex: 'linkmanCount'
        },
        {
          title: 'BigJSON',
          align: 'left',
          dataIndex: 'jsonCount'
        },
        {
          title: 'ID CardPhoto',
          align: 'left',
          dataIndex: 'idimageCount'
        },
        {
          title: 'FacePhoto',
          align: 'left',
          dataIndex: 'faceCount'
        },
        {
          title: 'ID CardInfo',
          align: 'left',
          dataIndex: 'idnoCount'
        },
        {
          title: 'Collection Info',
          align: 'left',
          dataIndex: 'bankcardCount'
        },
        {
          title: 'Apply',
          align: 'left',
          dataIndex: 'applyCount'
        },
        {
          title: 'Item',
          align: 'left',
          dataIndex: 'accessCount'
        },
        {
          title: 'Disbursement',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: 'RegistrationRate',
          align: 'left',
          dataIndex: 'optRegRate'
        },
        {
          title: 'RegistrationLoan ApplicationRate',
          align: 'left',
          dataIndex: 'regApplyRate'
        },
        {
          title: 'InstallLoan ApplicationRate',
          align: 'left',
          dataIndex: 'installApplyRate'
        },
        {
          title: 'ItemRate',
          align: 'left',
          dataIndex: 'applyAccessRate'
        },
        {
          title: 'Basic InfoRate/Before',
          align: 'left',
          dataIndex: 'baseBeforeRate'
        },
        // {
        //   title: 'Work info rate/Before',
        //   align: 'left',
        //   dataIndex: 'workBeforeRate'
        // },
        {
          title: 'ContactRate/Before',
          align: 'left',
          dataIndex: 'linkBeforeRate'
        },
        {
          title: 'JSONRate/Before',
          align: 'left',
          dataIndex: 'jsonBeforeRate'
        },
        {
          title: 'ID CardPhotoRate/Before',
          align: 'left',
          dataIndex: 'idCardBeforeRate'
        },
        {
          title: 'FacePhotoRate/Before',
          align: 'left',
          dataIndex: 'faceBeforeRate'
        },
        {
          title: 'Collection Info Rate/Before',
          align: 'left',
          dataIndex: 'bankCardBeforeRate'
        },
        {
          title: 'ApplyRate/Before',
          align: 'left',
          dataIndex: 'applyBeforeRate'
        },
        {
          title: 'DisbursementRate',
          align: 'left',
          dataIndex: 'loanBeforeRate'
        },
        {
          title: 'Registration-Bind Card Conversion Rate/Before',
          align: 'left',
          dataIndex: 'cardRegisterRate'
        }
      ],

      innerColumns: [
        {
          title: 'Category',
          align: 'left',
          dataIndex: 'appVersion',
        },
        {
          title: 'Install',
          align: 'left',
          dataIndex: 'installs',
        },
        {
          title: 'Registration',
          align: 'left',
          dataIndex: 'regCount'
        },
        {
          title: 'Basic Info',
          align: 'left',
          dataIndex: 'basicCount'
        },
        // {
        //   title: 'Work info',
        //   align: 'left',
        //   dataIndex: 'workCount'
        // },
        {
          title: 'Contact',
          align: 'left',
          dataIndex: 'linkmanCount'
        },
        {
          title: 'BigJSON',
          align: 'left',
          dataIndex: 'jsonCount'
        },
        {
          title: 'ID CardPhoto',
          align: 'left',
          dataIndex: 'idimageCount'
        },
        {
          title: 'FacePhoto',
          align: 'left',
          dataIndex: 'faceCount'
        },
        {
          title: 'ID CardInfo',
          align: 'left',
          dataIndex: 'idnoCount'
        },
        {
          title: 'Collection Info',
          align: 'left',
          dataIndex: 'bankcardCount'
        },
        {
          title: 'Apply',
          align: 'left',
          dataIndex: 'applyCount'
        },
        {
          title: 'Item',
          align: 'left',
          dataIndex: 'accessCount'
        },
        {
          title: 'Disbursement',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: 'RegistrationRate',
          align: 'left',
          dataIndex: 'optRegRate'
        },
        {
          title: 'RegistrationLoan ApplicationRate',
          align: 'left',
          dataIndex: 'regApplyRate'
        },
        {
          title: 'InstallLoan ApplicationRate',
          align: 'left',
          dataIndex: 'installApplyRate'
        },
        {
          title: 'ItemRate',
          align: 'left',
          dataIndex: 'applyAccessRate'
        },
        {
          title: 'Basic InfoRate/Before',
          align: 'left',
          dataIndex: 'baseBeforeRate'
        },
        // {
        //   title: 'Work info rate/Before',
        //   align: 'left',
        //   dataIndex: 'workBeforeRate'
        // },
        {
          title: 'ContactRate/Before',
          align: 'left',
          dataIndex: 'linkBeforeRate'
        },
        {
          title: 'JSONRate/Before',
          align: 'left',
          dataIndex: 'jsonBeforeRate'
        },
        {
          title: 'ID CardPhotoRate/Before',
          align: 'left',
          dataIndex: 'idCardBeforeRate'
        },
        {
          title: 'FacePhotoRate/Before',
          align: 'left',
          dataIndex: 'faceBeforeRate'
        },
        {
          title: 'Collection Info Rate/Before',
          align: 'left',
          dataIndex: 'bankCardBeforeRate'
        },
        {
          title: 'ApplyRate/Before',
          align: 'left',
          dataIndex: 'applyBeforeRate'
        },
        {
          title: 'DisbursementRate',
          align: 'left',
          dataIndex: 'loanBeforeRate'
        },
        {
          title: 'Registration-Bind Card Conversion Rate/Before',
          align: 'left',
          dataIndex: 'cardRegisterRate'
        }
      ],

      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    this.loadData(1);
    getApplistExcludingSubApp().then(res => {
      this.appList = res.data || [];
    })
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getConvertInstallData(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    getQueryParams () {
      const { dataDt } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt;
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO Filter
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    extpand (expanded, record) {
      // if(expanded){
      //   this.innerData = record.dataDetails;
      //
      //   console.log("------------->" + record);
      // } else {
      //   this.innerData = [];
      //   console.log("-------------> im close");
      // }

    },
    handleAdd () {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = 'Add new'
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    getUrl() {
      var params = this.getQueryParams()// Query conditions
      var url = '/api/web/webpublic/statistics/convertInstallDataExcel?startDate='+ params.startDate + '&endDate=' + params.endDate;

      if (params.appssidList) {
        url += '&appssidList=' + params.appssidList;
      }
      if (params.dataType) {
        url += '&dataType=' + params.dataType
      }
      return url;
    },
    downLoadData () {
      const file = {
        fileUrl: this.getUrl(),
        fileName: 'convertDataExcel.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    rowClassName(record,index){
      const date = new Date(record.dataDt)
      let className= date.getDay() % 6 === 0 ? 'table_weekendColor' : ''
      return className;
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>
